import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/data/news";
import { LayoutDashboard, Newspaper, PlusCircle, Users, ExternalLink, LogOut, Loader2, Rss, Settings, FileText, Youtube } from "lucide-react";

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
    isActive ? "bg-[#D92525] text-white" : "text-white/70 hover:bg-white/10 hover:text-white"
  }`;

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const nav = useNavigate();

  if (!ready) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0A0F1E] text-white"><Loader2 className="animate-spin" /></div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  const doLogout = async () => { await logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen bg-gray-50 font-sans-dev flex">
      {/* Sidebar */}
      <aside className="w-64 bg-[#0A0F1E] fixed inset-y-0 left-0 flex flex-col p-4 z-30">
        <div className="flex items-center gap-3 px-2 py-4 mb-4 border-b border-white/10">
          <img src={LOGO_URL} alt="Denva Post" className="h-9 w-auto" />
        </div>
        <nav className="flex flex-col gap-1 flex-1">
          <NavLink to="/admin" end className={linkCls} data-testid="nav-dashboard"><LayoutDashboard size={18} /> डैशबोर्ड</NavLink>
          <NavLink to="/admin/articles" className={linkCls} data-testid="nav-articles"><Newspaper size={18} /> खबरें</NavLink>
          <NavLink to="/admin/articles/new" className={linkCls} data-testid="nav-new-article"><PlusCircle size={18} /> नई खबर</NavLink>
          {(user.role === "admin" || user.role === "editor") && (
            <NavLink to="/admin/feeds" className={linkCls} data-testid="nav-feeds"><Rss size={18} /> फ़ीड इनबॉक्स</NavLink>
          )}
          {user.role === "admin" && (
            <NavLink to="/admin/team" className={linkCls} data-testid="nav-team"><Users size={18} /> टीम</NavLink>
          )}
          <NavLink to="/admin/epaper" className={linkCls} data-testid="nav-epaper"><FileText size={18} /> ई-पेपर</NavLink>
          <NavLink to="/admin/videos" className={linkCls} data-testid="nav-videos"><Youtube size={18} /> वीडियो</NavLink>
          {user.role === "admin" && (
            <NavLink to="/admin/settings" className={linkCls} data-testid="nav-settings"><Settings size={18} /> सेटिंग्स</NavLink>
          )}
        </nav>
        <div className="border-t border-white/10 pt-4 mt-4">
          <div className="flex items-center gap-3 px-2 mb-3">
            <img src={user.photo || LOGO_URL} alt="" className="w-9 h-9 rounded-full object-cover bg-white/10" />
            <div className="min-w-0">
              <div className="text-white text-sm font-semibold truncate">{user.name}</div>
              <div className="text-white/50 text-[11px] truncate">{user.designation || user.role}</div>
            </div>
          </div>
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-white/70 hover:bg-white/10">
            <ExternalLink size={16} /> वेबसाइट देखें
          </a>
          <button onClick={doLogout} data-testid="logout-btn" className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-white/70 hover:bg-[#D92525] hover:text-white transition-colors">
            <LogOut size={16} /> लॉगआउट
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
}
